module.exports = __webpack_public_path__ + "img/ep1-8.0f545585.jpg";